import { render } from "./CreateExtraService.vue?vue&type=template&id=19c40959&scoped=true"
import script from "./CreateExtraService.vue?vue&type=script&lang=js"
export * from "./CreateExtraService.vue?vue&type=script&lang=js"

import "./CreateExtraService.vue?vue&type=style&index=0&id=19c40959&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c40959"]])

export default __exports__